import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PaymentIcon = ({ iconSrc, alt, theme }) => {
    const styling = classNames({
        [theme.paymentIcon]: true,
    });

    return (
        <img src={ iconSrc } alt={ alt } className={ styling } />
    );
};

PaymentIcon.propTypes = {
    theme: PropTypes.shape({}),
    iconSrc: PropTypes.string,
    alt: PropTypes.string,
};

export default PaymentIcon;
